import { createContext, useContext } from 'react';

const ExamContext = createContext({})

export default ExamContext
